module.exports = __webpack_public_path__ + "img/KP.526d9fce.svg";